import { render, staticRenderFns } from "./MyShifts.vue?vue&type=template&id=ff360d28&"
import script from "./MyShifts.vue?vue&type=script&lang=js&"
export * from "./MyShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports